import { apiEndpoints } from './constants';

export enum EventType {
  ButtonClicked = 10002,
  PageLoad = 10003,
}

export enum PageType
{
  View = 1,
  Create = 2,
  Edit = 3,
  Participate = 4,
  List = 5,
  Analytics = 6,
  Admin = 7,
  Error = 8,
  Login = 9,
  Registration = 10,
  Custom = 11,
}

export enum ButtonType {
  Create = 1,
  Filter = 2,
  Search = 3,
  Export = 4,
  Navigate = 5,
  Schedule = 6,
  Insert = 7,
  Choose = 8,
  Launch = 9,
  Open = 10,
  Send = 11,
  Invite = 12,
  Close = 13,
  Save = 14,
  Expand = 15,
  Collapse = 16,
  Edit = 17,
  Delete = 18,
  Browse = 19,
  Load = 20,
  Add = 21,
  Menu = 22,
  Register = 23,
  Login = 24,
  Link = 25,
  Toggle = 26,
  Thumbnail = 27,
  Download = 28,
  Share = 29,
}

export enum ApplicationType {
  KPF = 15
}

export enum ApplicationFeatures {
  SUBSCRIPTION_FLOW = 'subscription_flow',
  ACCOUNT_MANAGEMENT = 'account_management',
}

let hostingKalturaApplicationCache: number | null = null;

const getHostingKalturaApplication = (): number | null => {
  if (!hostingKalturaApplicationCache) {
    try {
      const hostingKalturaApplication = sessionStorage.getItem('hostingKalturaApplication');
      if (hostingKalturaApplication) {
        hostingKalturaApplicationCache = Number(hostingKalturaApplication);
      }
    } catch {
      return null;
    }
  }
  return hostingKalturaApplicationCache;
};

export const trackPageLoadEvent = (
  pageType: PageType, // eventVar1
  pageName: string, // eventVar2
  feature: string | null = null,
  pageValue: string | null = null, // eventVar3
) => {
  const hostingKalturaApplication = getHostingKalturaApplication();
  sendReport({
    eventType: EventType.PageLoad,
    pageType,
    pageName,
    ...(pageValue && { pageValue }),
    ...(feature && { feature }),
    kalturaApplication: ApplicationType.KPF,
    ...(hostingKalturaApplication && { hostingKalturaApplication }),
  });
}

export const trackButtonClickEvent = (
  buttonType: ButtonType, // eventVar1
  buttonName: string, // eventVar2
  buttonValue: string | null = null, // eventVar3
  buttonInfo: string | null = null, // eventVar4
  feature: string | null = null,
) => {
  const hostingKalturaApplication = getHostingKalturaApplication();
  sendReport({
    eventType: EventType.ButtonClicked,
    buttonType,
    buttonName,
    ...(buttonValue && { buttonValue }),
    ...(buttonInfo && { buttonInfo }),
    ...(feature && { feature }),
    kalturaApplication: ApplicationType.KPF,
    ...(hostingKalturaApplication && { hostingKalturaApplication }),
  });
};

const sendReport = (payload: Record<string, any>) => {
  const apiUrl = new URL(apiEndpoints.kavaAnalytics);

  // send tracking event
  const requestOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': 'true',
    },
    body: JSON.stringify(payload),
  };

  fetch(apiUrl.href, requestOptions).catch((error) =>
    console.error(error)
  );
}
